<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors/contracts'"
            >Contracts</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link to="" style="color: #8cc63f !important">
            Update
          </router-link>
        </li>
      </ol>
    </div>
    <div class="col-12" style="margin-top: 60px">
      <contract-form
        contractType="InvestorContract"
        :activeContractID="activeContractID"
        :activeInvestorID="activeInvestorID"
        formType="update"
        @saveContract="updateContract"
      ></contract-form>
    </div>
  </div>
</template>
<script>
import ContractForm from "./forms/contractForm.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      validationMsg: null,
      activeContractID: null,
      activeInvestorID: null,
    };
  },
  components: {
    ContractForm,
  },
  created: function () {
    this.activeContractID = parseInt(this.$route.params.contractId);
    this.activeInvestorID = parseInt(this.$route.params.investorId);
  },
  methods: {
    formValidation(contract) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";

      if (!contract.start_date) {
        missingFieldsString += "Contract start date is not selected, ";
        result.isValid = false;
      }
      if (!contract.maturity_date) {
        missingFieldsString += "Contract maturity date is not selected, ";
        result.isValid = false;
      }
      if (!contract.investor_id) {
        missingFieldsString += "Investor is not selected, ";
        result.isValid = false;
      }
      if (!contract.plan_id) {
        missingFieldsString += "Plan is not selected, ";
        result.isValid = false;
      }
      if (!contract.invested_principal) {
        missingFieldsString += "Principal field is empty, ";
        result.isValid = false;
      }
      let statusList = ["active", "inactive", "notstarted", "closed"];

      if (!statusList.includes(contract.status)) {
        missingFieldsString += "Contract status should be selected, ";
        result.isValid = false;
      }
      let paymentTypes = ["cash", "banktransfer", "cheque", "blockchain"];

      if (!paymentTypes.includes(contract.payment_type)) {
        missingFieldsString += "Contract payment should be selected, ";
        result.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    updateContract(contract) {
      const { isValid, message } = this.formValidation(contract);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      this.$store.dispatch("updateInvestorContract", contract);
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      updatedInvestorContract: (state) =>
        state.contractStore.investorContractUpdate.updatedInvestorContract,
      updateInvestorContractStatus: (state) =>
        state.contractStore.investorContractUpdate.updateInvestorContractStatus,
    }),
  },
  watch: {
    updateInvestorContractStatus() {
      if (this.updateInvestorContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push(
            "/" + this.authUser.userable_type + "/investors/contracts"
          );
        });
      } else if (this.updateInvestorContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/updateInvestorContract.vue